import ErrorUtils from '~/utils/error_utils';
import { objectToFormData } from '~/utils/utils';

export default {
    postIn5Template(payload) {
        payload = objectToFormData(payload);

        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/manage-media/in5-upload',
                type: 'POST',
                data: payload,
                global: false,
                contentType: false,
                processData: false,
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to upload In5 template', xhr);
                reject(xhr.responseJSON);
            });
        });
    },

    updateMediaTemplate(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/manage-media/update-template/' + payload.id,
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to update media template', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    searchUsers(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/manage-media/user-search',
                type: 'GET',
                data: params,
                global: false
            }).done((json) => {
                resolve(json);
            }).fail((xhr) => {
                console.error('Users search failed.', xhr);
                reject(xhr);
            });
        });
    },

    cloneAsset(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/media/clone',
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(xhr.responseJSON);
            });
        });
    },

    getMediaForm(id) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/manage-media/form-json/' + id,
                type: 'GET',
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to load approval request.', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getOrgMediaData(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/manage-media/media-data-json/',
                type: 'GET',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to get media data.', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getTemplates(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/media-template/dt',
                type: 'GET',
                data: params,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to retrieve available templates.', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    updateMediaForm(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/manage-media/form/' + payload.media_id,
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to update media settings', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getAutoPayOptions(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/manage-media/check-autopay',
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to retrieve auto-pay options.', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    searchMedia(params) {
        const xhr = $.ajax({
            url: '/manage-media/search',
            type: 'GET',
            data: params,
            global: false
        });
        const promise = new Promise((resolve, reject) => {
            xhr
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                if (!xhr.statusText =='abort') {
                    console.error('Manage media search failed.', xhr);
                    reject(ErrorUtils.createErrorFromXhr(xhr));
                }
            });
        });
        promise.abort = function() {
            xhr.abort();
        };
        return promise;
    },

    publishBaseTemplate(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/media/publish-template/',
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getActiveMarkupForm(media_id) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/manage-media/markup-json/',
                type: 'GET',
                data: {
                    'media_id' : media_id,
                    'retrieve_active_id' : true
                },

                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(xhr.responseJSON);
            });
        });
    },

saveMarkup(payload)
{
    return new Promise((resolve, reject) => {
        $.ajax({
            url: `/manage-media/markup/${payload.id}`,
            type: 'POST',
            data: payload,
            global: false
        })
        .done((data) => {
            resolve(data);
        })
        .fail((xhr) => {
            reject(xhr.responseJSON);
        });
    });
},

    unpublishBaseTemplate(payload) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/media/unpublish-template/',
                type: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getAccessSettingsStats(mediaId) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/manage-media/access-settings-stats/${mediaId}`,
                type: 'GET',
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Manage media search failed.', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getMediaList(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/manage-media/search',
                method: 'GET',
                data: params,
                global: false
            })
            .done(data => {
                resolve(data);
            })
            .fail(xhr => {
                console.error('Failed to load media list search.', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        })
    },

    getStandardTemplateOrgs(mediaId) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/media-template/standard-template-org-ids/${mediaId}`,
                method: 'GET',
                global: false
            })
            .done(data => {
                resolve(data);
            })
            .fail(xhr => {
                console.error('Failed to load standard template org ids.', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        })
    }
};

